import React, { useEffect, useState } from "react";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { Application } from "../../models/application";
import { request } from "../../interfaces/networkManager";

interface IApplicationPickerProps {
    value: string;
    onChange: (value: string) => void;
}

const ApplicationPicker = ({ value, onChange }: IApplicationPickerProps) => {
    const [options, setOptions] = useState<Application[]>([]);

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const applications = await request<Application[]>('/applications');
                setOptions(Array.isArray(applications) ? applications : []);
            } catch (error) {
                console.error('Erreur lors de la récupération des applications:', error);
                setOptions([]);
            }
        };
        fetchApplications();
    }, []);     

	return (
        <FormControl fullWidth>
            <InputLabel id="application-label">Application</InputLabel>
            <Select 
                labelId="application-label"
                name="application"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                label="Application"
                required
                id="application"
            >
                <MenuItem value="">Toutes</MenuItem>
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
	)
}

export default ApplicationPicker;
